import { render, staticRenderFns } from "./ExpertTem.vue?vue&type=template&id=97718446&scoped=true"
import script from "./ExpertTem.vue?vue&type=script&lang=js"
export * from "./ExpertTem.vue?vue&type=script&lang=js"
import style0 from "./ExpertTem.vue?vue&type=style&index=0&id=97718446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97718446",
  null
  
)

export default component.exports